<template>
    <Page :header="content[lang_].name">
        <template #body>
            <div class="flex w-full flex-column">
                <InlineMessage severity="error" v-if="errors" v-for="e of errors">{{ e }}</InlineMessage>

                <InlineMessage severity="success" v-if="success">Успех</InlineMessage>

                <p>{{content[lang_].text}}</p>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Event from '@/assets/js/Event'
import { useRoute } from 'vue-router'
import Page from '@/components/sides/Page.vue'

export default {
    name: 'PaypalSuccess',
    data() {
        return {
            content:{
                en: {
                    name: 'Request for Repeat Scan',
                    text: 'Now you can close the page',
                },
                ru: {
                    name: 'Запрос на повторное сканирование',
                    text: 'Теперь можно закрыть страницу',
                }
            },
            id: null,
            errors: [],
            success: false,
        }
    },
    components: {
        Page
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
    watch: {
        
    },
    methods: {
        go_main(){
            this.$router.push({
                path: '/'
            })
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
        const route = useRoute()

        if(route.params.id!='') this.id = route.params.id

        console.log('this.id', this.id)

        if(this.id && this.id.length==24){
            await this.connect.repeat_scat(this.id).then((response) => {
                console.log('response', response)

                if(response.result){
                    this.success = true
                } else {
                    this.errors = response.errors
                }
            })
        }
    },
}
</script>

 

